
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import PublicCard from './card/publicCard.vue'
import NewSwiper from '@xt/www/components/newSwiper/index.vue'
import { Observer } from 'mobx-vue'
import UserContentPop from '@xt/www/components/classhour/pop-content/index.vue'
import type { DairyOption } from '@xt/client/entities/course-v2/user-content'
import SwiperBtn from './swiperBtn/index.vue'

@Observer
@Component({
  components: {
    NewSwiper,
    PublicCard,
    SwiperBtn,
    UserContentPop
  }
})
export default class extends Vue {
  @Prop({ required: true }) ids: string[]

  @Ref()
  swiper: {
    handlePrev: () => void
    handleNext: () => void
  }

  @Ref()
  userContentPop: {
    showPop: (options: DairyOption) => void
    hidePop: () => void
  }

  activeIndex: number = 0

  needLogin: boolean = false

  get dataSource() {
    return this.$store.$homeV2.PublicCourse
  }

  handleChange(index) {
    this.activeIndex = index
  }

  handleClickMore() {
    window.open('/video')
  }

  handleClick(momentId: string) {
    if (this.userContentPop) {
      this.userContentPop.showPop({ type: 'dairy', momentId })
    }
  }

  handleOpenLogin() {
    this.needLogin = true
    this.userContentPop.hidePop()
  }

  handleClosed() {
    if (this.needLogin) {
      this.$store.$storeUser.onToggleVisible(true)
      this.needLogin = false
    }
  }

  prev() {
    if (!this.swiper) return
    this.swiper.handlePrev()
  }

  next() {
    if (!this.swiper) return
    this.swiper.handleNext()
  }

  created(): void {}

  mounted(): void {
    if (Array.isArray(this.toJS(this.ids)) && this.ids.length > 0) {
      this.$store.$homeV2.PublicCourse.loadPublicCourse(this.toJS(this.ids))
    }
  }

  updated(): void {}

  destroyed(): void {}
}
